module.exports = __webpack_public_path__ + "fc160e51bcc93853f134690127f38e8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/7.jpg
// module id = 528
// module chunks = 0